/**
 * questionnaire接口
 */
import axios from '../utils/https' // 导入http中创建的axios实例

const questionnaire = {
  // 问卷维护
  getQuestionnaireBasicInfo (params) {
    return axios.get('/api/questionnaire/GetQuestionnaireBasicInfo', { params })
  },
  getQuestionnaireUserInfo (params) {
    return axios.get('/api/questionnaire/GetQuestionnaireUserInfo', { params })
  },
  getQuestionnaireBodyInfo (params) {
    return axios.get('/api/questionnaire/GetQuestionnaireBodyInfo', { params })
  },
  editQuestionnaireBasic (params) {
    return axios.post('/api/questionnaire/EditQuestionnaireBasic', params)
  },
  editQuestionnaireUser (params) {
    return axios.post('/api/questionnaire/EditQuestionnaireUser', params)
  },
  adjustQuestionnaireUser (params) {
    return axios.post('/api/questionnaire/AdjustQuestionnaireUser', params)
  },
  editQuestionnaireBody (params) {
    return axios.post('/api/questionnaire/EditQuestionnaireBody', params)
  },
  editQuestionnaireElement (params) {
    return axios.post('/api/questionnaire/EditQuestionnaireElement', params)
  },
  deleteQuestionnaire (params) {
    return axios.delete('/api/questionnaire/DeleteQuestionnaire', { params })
  },
  sortQuestionnaire (params) {
    return axios.post('/api/questionnaire/SortQuestionnaire', params)
  },
  // 问卷查询
  getQuestionnaireDetail (params) {
    return axios.get('/api/questionnaire/GetQuestionnaireDetail', { params })
  },
  getQuestionnaireList (params) {
    return axios.get('/api/questionnaire/GetQuestionnaireList', { params })
  },
  // 管理问卷状态
  checkQuestionnaire (params) {
    return axios.post('/api/questionnaire/CheckQuestionnaire', params)
  },
  startQuestionnaire (params) {
    return axios.post('/api/questionnaire/StartQuestionnaire', params)
  },
  endQuestionnaire (params) {
    return axios.post('/api/questionnaire/EndQuestionnaire', params)
  },
  colseQuestionnaire (params) {
    return axios.post('/api/questionnaire/ColseQuestionnaire', params)
  },
  resetQuestionnaire (params) {
    return axios.post('/api/questionnaire/ResetQuestionnaire', params)
  },
  // 问卷结果
  getQuestionnaireResult (params) {
    return axios.get('/api/questionnaire/GetQuestionnaireResult', { params })
  },
  getQuestionnaireResults (params) {
    return axios.get('/api/questionnaire/GetQuestionnaireResults', { params })
  },
  exportQuestionnaireResult (params) {
    return axios({
      method: 'post',
      url: '/api/questionnaire/ExportQuestionnaireResult',
      data: params,
      responseType: 'blob'
    })
  },
  exportQuestionnaireResults (params) {
    return axios({
      method: 'post',
      url: '/api/questionnaire/ExportQuestionnaireResults',
      data: params,
      responseType: 'blob'
    })
  },
  // 问卷进度
  getQuestionnaireProgress (params) {
    return axios.get('/api/questionnaire/GetQuestionnaireProgress', { params })
  },
  // 问卷明细

  // 重新答卷
  againQuestionnaire (params) {
    return axios.post('/api/questionnaire/AgainQuestionnaire', params)
  }
}

export default questionnaire
